export class AutorenderAuthError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'AutorenderAuthError';
  }
}

export class AutorenderUploadError extends Error {
  statusCode: number;

  constructor(message: string, statusCode: number) {
    super(message);
    this.name = 'AutorenderUploadError';
    this.statusCode = statusCode;
  }
}

export class AutorenderNetworkError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'AutorenderNetworkError';
  }
}
